// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './common';
export * from './form';
export * from './layout.module';
export * from './user';
// @endindex